export default __webpack_public_path__ + "static/media/illus-choose-datasets.07f31290.svg";